import { EventDate, EventDateSearch } from '@givebacks/api/store';
import { createTable } from 'core/Packages';

type TableInstanceMeta = {
  causeId: string;
  eventId: string;
};

const EventCalendarTableInstance = createTable<EventDate, EventDateSearch, TableInstanceMeta>();

export { EventCalendarTableInstance };
export type { TableInstanceMeta };
